import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import { dealRoomTheme } from "@/deal-room/theme";

import { initPostHog } from "./analytics/posthog";
import "./styles/globals.css";

import { router } from "./routes";

// Start analytics (heatmaps + autocapture) before first paint. No-ops on
// localhost unless VITE_POSTHOG_KEY is set.
initPostHog();

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60_000,
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});

const root = document.getElementById("root");
if (!root) throw new Error("#root element missing from index.html");

createRoot(root).render(
    <StrictMode>
        <ThemeProvider theme={dealRoomTheme}>
            <CssBaseline />
            <QueryClientProvider client={queryClient}>
                <RouterProvider router={router} />
            </QueryClientProvider>
        </ThemeProvider>
    </StrictMode>,
);
